import axiosInstance from "../../../utils/axiosConfig";
import { API_URL } from "../../../constant";
import React, { useEffect, useRef, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { noTransaction } from "../../../assets/images";
import { useAuth } from "../../../context/auth-context";
import { useInView } from "react-intersection-observer";
import { HiOutlineTrash } from "react-icons/hi2";
import { CtaLinkSummary } from "../../../components/CtaLink";

const History = () => {
  const { isAuthenticated } = useAuth();
  const [historyLoader, setHistoryLoader] = useState<boolean>(false);
  const [histories, setHistories] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const divRef = useRef<HTMLDivElement | null>(null);
  const [ref, inView] = useInView();
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
  const [refetchCount, setRefetchCount] = useState<number>(1);

  useEffect(() => {
    setHistoryLoader(true);
    axiosInstance
      .get(
        `${API_URL}api/notifications/advanced?status=all&type=sliders&page=${page}`
      )
      .then((r: any) => {
        // console.log(r.data);
        if (r.data.data.notifications?.length >= 1) {
          const uniqueNotifications = Array.from(
            new Map(
              r.data.data.notifications.map((hist: any) => [hist._id, hist])
            ).values()
          );
          // Replace histories instead of appending
          setHistories((prev) =>
            page === 1 ? uniqueNotifications : [...prev, ...uniqueNotifications]
          );
        }
        setTotalPages(r.data?.data?.metadata?.totalPages);
        setHistoryLoader(false);
      })
      .catch((e: any) => {
        setHistoryLoader(false);
      });
  }, [page, isAuthenticated, refetchCount]);

  useEffect(() => {
    if (inView) {
      if (page < totalPages) {
        setPage((prev) => prev + 1);
      }
    }
  }, [inView, totalPages]);

  function formatDate(timestamp: string | number | Date) {
    const now = new Date();
    const date = new Date(timestamp);

    const isToday = date.toDateString() === now.toDateString();
    const isYesterday =
      date.toDateString() ===
      new Date(now.setDate(now.getDate() - 1)).toDateString();

    if (isToday) {
      return "Today " + formatTime(date);
    } else if (isYesterday) {
      return "Yesterday " + formatTime(date);
    } else {
      return formatDateOnly(date) + " , " + formatTime(date);
    }
  }

  function formatTime(date: Date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");

    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  function formatDateOnly(date: Date) {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  console.log(histories);

  return (
    <div
      ref={divRef}
      className="w-full  pt-4 pb-4  lgss:h-[420px]  overflow-auto scrollbar-thumb-[#AEBCC6]    scrollbar-thin"
    >
      <div className="flex justify-between   text-[#617889] text-[15px] font-medium items-center p-4 bg-[#1C2227] rounded-xl">
        <h4 className="w-3/5">Title</h4>
        <h4 className="w-2/5">Date</h4>
      </div>
      {histories.length >= 1 ? (
        <div className="w-full ">
          <>
            {histories.map((history, index) => {
              const deletehistory = () => {
                if (loadingIndex !== history?._id) {
                  setLoadingIndex(history?._id);
                  axiosInstance
                    .delete(
                      `${API_URL}api/notifications/advanced/${history?._id}`
                    )
                    .then(() => {
                      // Immediately remove the deleted history from the state
                      setHistories((prev) =>
                        prev.filter((hist) => hist._id !== history?._id)
                      );
                      setLoadingIndex(null);
                    })
                    .catch((e: any) => {
                      setLoadingIndex(null);
                      console.log(e.response.data.message);
                    });
                }
              };

              const formattedDate = formatDate(history.createdAt);
              return (
                <>
                  <div
                    className={"py-4 flex justify-between items-start gap-2"}
                    key={index}
                  >
                    <div className="text-[15px] w-3/5 flex justify-start items-start gap-2 font-bold  text-gray-300">
                      <div
                        className={
                          history?.status === "expired"
                            ? "w-2 h-2 rounded-full bg-gray-600 mt-2"
                            : history?.status === "scheduled"
                            ? "w-2 h-2 rounded-full bg-yellow-600 mt-2"
                            : history?.status === "active"
                            ? "w-2 h-2 rounded-full bg-green-600 mt-2"
                            : ""
                        }
                      ></div>
                      <div className="mt-0">
                        <h4>
                          {" "}
                          {history.images[0]?.url
                            ? history.images[0].url.split("/").pop() // Extract the image name from the URL
                            : "No Image"}
                        </h4>
                        <CtaLinkSummary link={history?.link} />
                      </div>
                    </div>
                    <div className="text-[14px] w-2/5 font-bold flex justify-between items-center text-gray-300">
                      {formattedDate}
                      {history?.status === "active" ||
                      history?.status === "scheduled" ? (
                        <div>
                          {loadingIndex === history?._id ? (
                            <TailSpin color="#FFFFFF" height={30} width={30} />
                          ) : (
                            <HiOutlineTrash
                              onClick={deletehistory}
                              className="text-red-500 cursor-pointer"
                            />
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </>
              );
            })}

            <div ref={ref} className=""></div>
          </>
        </div>
      ) : (
        !historyLoader && (
          <div className="flex flex-col justify-center mt-10 items-center">
            <img src={noTransaction} alt="" />
            <h4 className="font-bold text-[#869AA9] pt-2">No history</h4>
            <p className=" text-[#869AA9] pt-2 text-[12px]">
              All sliders will show up here
            </p>
          </div>
        )
      )}
      {historyLoader && (
        <div className="mt-6 flex justify-center items-center">
          <TailSpin color="#0B75C2" height={50} width={70} />
        </div>
      )}
    </div>
  );
};

export default History;
